/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HighlightedInstallmentDto } from './HighlightedInstallmentDto';
import {
    HighlightedInstallmentDtoFromJSON,
    HighlightedInstallmentDtoFromJSONTyped,
    HighlightedInstallmentDtoToJSON,
    HighlightedInstallmentDtoToJSONTyped,
} from './HighlightedInstallmentDto';

/**
 * Une ligne = une quittance (échéancier d'un contrat), avec une échéance mise en avant, une progression et un état agrégé.
 * 
 * @export
 * @interface QuittanceListItem
 */
export interface QuittanceListItem {
    /**
     * quittanceId — sert au GET détail des échéances
     * @type {string}
     * @memberof QuittanceListItem
     */
    id: string;
    /**
     * Id de l'échéance-paiement (distinct du quittanceId) pour la page de détail /back-office/prelevements/{paymentScheduleId}?tab=info
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    paymentScheduleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    receiptNumber: string;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    contractNumber: string;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    subscriberName: string;
    /**
     * EMANDAT | CSV_HBS | EXTERNE
     * @type {string}
     * @memberof QuittanceListItem
     */
    withdrawalModeCode: string;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    withdrawalModeLabel: string;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    periodicityLabel: string;
    /**
     * Date d'effet du contrat (optionnelle, absente si le contrat n'a pas de date d'effet). Colonne triable via sortBy = effectiveDate.
     * 
     * @type {Date}
     * @memberof QuittanceListItem
     */
    contractEffectiveDate?: Date | null;
    /**
     * Badge grossier de ligne : ERREUR (impayé/rejeté/problème transmission) | EN_RETARD | A_VENIR | SOLDEE. Pour l'affichage précis, se baser sur highlightedInstallment.statusCode/statusLabel.
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    stateCode: string;
    /**
     * 
     * @type {number}
     * @memberof QuittanceListItem
     */
    installmentsCount: number;
    /**
     * 
     * @type {number}
     * @memberof QuittanceListItem
     */
    paidCount: number;
    /**
     * impayées + rejetées (badge rouge si > 0)
     * @type {number}
     * @memberof QuittanceListItem
     */
    errorCount: number;
    /**
     * 
     * @type {number}
     * @memberof QuittanceListItem
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof QuittanceListItem
     */
    paidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof QuittanceListItem
     */
    remainingAmount: number;
    /**
     * Vrai si le prélèvement est une donnée de test (écran ADMIN uniquement). Piloté par le filtre filters.isTest (tri-état : absent = tout, false = exclure les tests, true = uniquement les tests).
     * 
     * @type {boolean}
     * @memberof QuittanceListItem
     */
    isTest: boolean;
    /**
     * null si la quittance n'a aucune échéance
     * @type {HighlightedInstallmentDto}
     * @memberof QuittanceListItem
     */
    highlightedInstallment?: HighlightedInstallmentDto | null;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    plateformeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuittanceListItem
     */
    plateformeName?: string | null;
}

/**
 * Check if a given object implements the QuittanceListItem interface.
 */
export function instanceOfQuittanceListItem(value: object): value is QuittanceListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('receiptNumber' in value) || value['receiptNumber'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('subscriberName' in value) || value['subscriberName'] === undefined) return false;
    if (!('withdrawalModeCode' in value) || value['withdrawalModeCode'] === undefined) return false;
    if (!('withdrawalModeLabel' in value) || value['withdrawalModeLabel'] === undefined) return false;
    if (!('periodicityLabel' in value) || value['periodicityLabel'] === undefined) return false;
    if (!('stateCode' in value) || value['stateCode'] === undefined) return false;
    if (!('installmentsCount' in value) || value['installmentsCount'] === undefined) return false;
    if (!('paidCount' in value) || value['paidCount'] === undefined) return false;
    if (!('errorCount' in value) || value['errorCount'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('paidAmount' in value) || value['paidAmount'] === undefined) return false;
    if (!('remainingAmount' in value) || value['remainingAmount'] === undefined) return false;
    if (!('isTest' in value) || value['isTest'] === undefined) return false;
    return true;
}

export function QuittanceListItemFromJSON(json: any): QuittanceListItem {
    return QuittanceListItemFromJSONTyped(json, false);
}

export function QuittanceListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuittanceListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'paymentScheduleId': json['paymentScheduleId'] == null ? undefined : json['paymentScheduleId'],
        'receiptNumber': json['receiptNumber'],
        'contractId': json['contractId'],
        'contractNumber': json['contractNumber'],
        'productName': json['productName'],
        'subscriberName': json['subscriberName'],
        'withdrawalModeCode': json['withdrawalModeCode'],
        'withdrawalModeLabel': json['withdrawalModeLabel'],
        'periodicityLabel': json['periodicityLabel'],
        'contractEffectiveDate': json['contractEffectiveDate'] == null ? undefined : (new Date(json['contractEffectiveDate'])),
        'stateCode': json['stateCode'],
        'installmentsCount': json['installmentsCount'],
        'paidCount': json['paidCount'],
        'errorCount': json['errorCount'],
        'totalAmount': json['totalAmount'],
        'paidAmount': json['paidAmount'],
        'remainingAmount': json['remainingAmount'],
        'isTest': json['isTest'],
        'highlightedInstallment': json['highlightedInstallment'] == null ? undefined : HighlightedInstallmentDtoFromJSON(json['highlightedInstallment']),
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
    };
}

export function QuittanceListItemToJSON(json: any): QuittanceListItem {
    return QuittanceListItemToJSONTyped(json, false);
}

export function QuittanceListItemToJSONTyped(value?: QuittanceListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'paymentScheduleId': value['paymentScheduleId'],
        'receiptNumber': value['receiptNumber'],
        'contractId': value['contractId'],
        'contractNumber': value['contractNumber'],
        'productName': value['productName'],
        'subscriberName': value['subscriberName'],
        'withdrawalModeCode': value['withdrawalModeCode'],
        'withdrawalModeLabel': value['withdrawalModeLabel'],
        'periodicityLabel': value['periodicityLabel'],
        'contractEffectiveDate': value['contractEffectiveDate'] == null ? undefined : ((value['contractEffectiveDate'] as any).toISOString()),
        'stateCode': value['stateCode'],
        'installmentsCount': value['installmentsCount'],
        'paidCount': value['paidCount'],
        'errorCount': value['errorCount'],
        'totalAmount': value['totalAmount'],
        'paidAmount': value['paidAmount'],
        'remainingAmount': value['remainingAmount'],
        'isTest': value['isTest'],
        'highlightedInstallment': HighlightedInstallmentDtoToJSON(value['highlightedInstallment']),
        'plateformeId': value['plateformeId'],
        'plateformeName': value['plateformeName'],
    };
}

